import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles/Theme';
import { GlobalStyles } from './styles/GlobalStyles';
import { AuthProvider } from './contexts/AuthContext';

import MainLayout from './layouts/MainLayout';
import AdminLayout from './layouts/AdminLayout';

import Home from './pages/Home';
import About from './pages/About';
import CompanyPage from './pages/CompanyPage';
import Team from './pages/Team';
import Contact from './pages/Contact';

import AdminLogin from './pages/Admin/Login';
import AdminDashboard from './pages/Admin/Dashboard';
import EditHome from './pages/Admin/EditHome';
import EditAbout from './pages/Admin/EditAbout';
import ManageCompanies from './pages/Admin/ManageCompanies';
import EditTeam from './pages/Admin/EditTeam';
import EditContact from './pages/Admin/EditContact';
import ManageUsers from './pages/Admin/ManageUsers';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<MainLayout />}>
              <Route index element={<Home />} />
              <Route path="about" element={<About />} />
              <Route path="companies/:slug" element={<CompanyPage />} />
              <Route path="team" element={<Team />} />
              <Route path="contact" element={<Contact />} />
            </Route>

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="home" element={<EditHome />} />
              <Route path="about" element={<EditAbout />} />
              <Route path="companies" element={<ManageCompanies />} />
              <Route path="team" element={<EditTeam />} />
              <Route path="contact" element={<EditContact />} />
              <Route path="users" element={<ManageUsers />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
